export const IK_IDK_QUESTION_ID = "ik-question-id";
export const REASON_NEW_VEHICLE_QUESTION_ID = "reason-new-vehicle-question-id";
export const BUDGET_QUESTION_ID = "budget-question-id";
export const FEATURE_QUESTION_ID = "feature-question-id";
export const LIFESTYLE_QUESTION_ID = "lifestyle-question-id";
export const VEHICLE_POWER_QUESTION_ID = "vehicle-power-question-id";
export const VEHICLE_TYPE_QUESTION_ID = "vehicle-type-question-id";
export const VEHICLE_CONDITION_QUESTION_ID = "vehicle-condition-question-id";
export const SELECTED_VEHICLE_CONFIRMATION_QUESTION_ID =
  "selected-vehicle-confirmation-question-id";
export const CUSTOMER_INFO_QUESTION_ID = "customer-info-question-id";
export const TEST_DRIVE_APPROVAL_QUESTION_ID =
  "test-drive-approval-question-id";
export const TRADE_IN_QUESTION_ID = "trade-in-question_id";
export const CURRENT_CUSTOMER_VEHICLE_QUESTION_ID =
  "current-customer-vehicle-question-id";
export const TRADE_IN_PAY_OFF_QUESTION_ID = "trade-in-pay-off-question-id";
export const PAYMENT_MODE_QUESTION_ID = "payment-mode-question-id";
export const PICK_CARS_QUESTION_ID = "pick-cars-question-id";
export const EV_SPECIFIC_Q1_QUESTION_ID = "ev-specific-q1-id";
export const EV_SPECIFIC_Q2_QUESTION_ID = "ev-specific-q2-id";
export const MONTHLY_BUDGET_QUESTION_ID = "monthly-budget-question-id";

export const IK_IDK_PARENT_QUESTION_ID = "ik-idk-parent-question-id";
export const REASON_NEW_VEHICLE_PARENT_QUESTION_ID =
  "reason-new-vehicle-parent-question-id";
export const VEHICLE_TYPE_PARENT_QUESTION_ID =
  "vehicle-type-parent-question-id";
export const VEHICLE_POWER_PARENT_QUESTION_ID =
  "vehicle-power-parent-question-id";
export const LIFESTYLE_PARENT_QUESTION_ID = "lifestyle-parent-question-id";
export const FEATURE_PARENT_QUESTION_ID = "feature-parent-question-id";
export const FINANCE_BUDGET_PARENT_QUESTION_ID =
  "finance-budget-parent-question-id";
export const PICK_CARS_PARENT_QUESTION_ID = "pick-cars-parent-question-id";
export const CUSTOMER_INFO_PARENT_QUESTION_ID =
  "customer-info-parent-question-id";
export const TEST_DRIVE_APPROVAL_PARENT_QUESTION_ID =
  "test-drive-approval-parent-question-id";
export const EV_SPECIFIC_PARENT_QUESTION_ID = "ev-specific-parent-question-id";
export const ANR_UPDATE_PROFILE_PARENT_QUESTION_ID =
  "anr-update-profile-parent-question-id";
export const ANL_UPDATE_PROFILE_PARENT_QUESTION_ID =
  "anl-update-profile-parent-question-id";
export const ANS_UPDATE_PROFILE_PARENT_QUESTION_ID =
  "ans-update-profile-parent-question-id";
export const AWF_UPDATE_PROFILE_PARENT_QUESTION_ID =
  "awf-update-profile-parent-question-id";
export const AGM_UPDATE_PROFILE_PARENT_QUESTION_ID =
  "agm-update-profile-parent-question-id";
export const AMI_UPDATE_PROFILE_PARENT_QUESTION_ID =
  "ami-update-profile-parent-question-id";
export const AKS_UPDATE_PROFILE_PARENT_QUESTION_ID =
  "aks-update-profile-parent-question-id";
export const APC_UPDATE_PROFILE_PARENT_QUESTION_ID =
  "apc-update-profile-parent-question-id";
export const AKL_UPDATE_PROFILE_PARENT_QUESTION_ID =
  "akl-update-profile-parent-question-id";
export const AMS_UPDATE_PROFILE_PARENT_QUESTION_ID =
  "ams-update-profile-parent-question-id";
export const MVB_UPDATE_PROFILE_PARENT_QUESTION_ID =
  "mvb-update-profile-parent-question-id";
export const MNB_UPDATE_PROFILE_PARENT_QUESTION_ID =
  "mnb  -update-profile-parent-question-id";
